// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"ad-modal_buttonsContainer__QYVv6","subtitle":"ad-modal_subtitle__uZQ8D","subtitleCell":"ad-modal_subtitleCell__fBPSt"};